var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThirdweb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 23,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M20.223.008c.23.048.447.144.637.283.212.168.375.391.47.645l1.81 4.524a1626.34 1626.34 0 0 0 2.011 5.028c.351.88.7 1.76 1.058 2.636a1.456 1.456 0 0 1 0 1.135l-3.065 7.645c-.203.506-.57.82-1.111.903-.673.101-1.274-.23-1.517-.82-.575-1.415-1.138-2.834-1.705-4.252l-2.883-7.212c-.853-2.14-1.708-4.28-2.564-6.42-.284-.71-.559-1.424-.855-2.128A1.423 1.423 0 0 1 13.5.03c.025-.006.049-.015.072-.022h6.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M8.279.008c.075.02.15.039.225.065a1.344 1.344 0 0 1 .85.792c.659 1.634 1.314 3.27 1.966 4.905a39864.963 39864.963 0 0 1 2.953 7.377 1.408 1.408 0 0 1 0 1.094l-1.092 2.724-2.002 4.984a1.407 1.407 0 0 1-1.296.879 1.43 1.43 0 0 1-1.365-.927c-.617-1.566-1.247-3.127-1.87-4.69-.837-2.116-1.678-4.23-2.523-6.343l-2.58-6.453C1.219 3.6.896 2.785.565 1.97A1.42 1.42 0 0 1 1.273.128c.12-.049.245-.09.372-.12H8.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M38.036 13.913c-.182.616-.455 1.197-.687 1.79a1369.26 1369.26 0 0 1-2.026 5.064c-.156.386-.314.772-.465 1.16a1.428 1.428 0 0 1-1.328.897 1.424 1.424 0 0 1-1.322-.905l-2.946-7.37-2.548-6.365L24.22 1.95a1.41 1.41 0 0 1 .994-1.915c.027-.006.054-.015.08-.023h6.651c.021.006.041.014.062.019a1.415 1.415 0 0 1 1.036.888 13578.022 13578.022 0 0 1 4.209 10.529c.266.669.563 1.326.781 2.014l.003.451Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 11.364,
    x2: 27.384,
    y1: 1.861,
    y2: 17.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6200C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.574,
    x2: 15.442,
    y1: 1.855,
    y2: 17.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6200C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 23.084,
    x2: 39.101,
    y1: 1.855,
    y2: 17.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6200C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdweb);
export default __webpack_public_path__ + "static/media/thirdweb.8de9113ffa72d7d8b0ff01ea896ea782.svg";
export { ForwardRef as ReactComponent };